import moment from "moment";

export default function getDaysLeft (returnDate) {
    const result = moment(returnDate).startOf('day').diff(moment(Date.now()).startOf('day'), 'days');
    return result;
  };